module.exports = __webpack_public_path__ + "static/media/52991436_2452971488111361_7098283413488009216_o.ac0a9eec.jpg";